export default {"src":"/_next/static/media/RoyalTrain.bdc7f9a4.svg","height":150,"width":110,"blurWidth":0,"blurHeight":0};